import share from '../../../assets/share.png'
import { useTranslation } from 'react-i18next'
import FeedBack from '../../../components/feedback'

function ShareUSSD() {
  const { t } = useTranslation()

  return (
    <article>
      <h1 className='text-xl md:text-2xl font-bold dark:text-secondaryGreen'>
        {t('helpCenter.sidebar.How to share the group USSD code to others?')}
      </h1>
      <div className='w-full h-[1px] bg-[#eff2f5] dark:bg-[#303032] mt-4 '></div>
      <section className='mt-8'>
        <p className='mb-2'>
          <span className='font-semibold'>Step 1: </span>
          {t('helpCenter.Crowdfunding.shareUSSD.step1')}
        </p>
        <p>
          <span className='font-semibold'>Step 2: </span>
          {t('helpCenter.Crowdfunding.shareUSSD.step2.part1')}
          <img src={share} alt='icon' className='inline-flex' />
          {t('helpCenter.Crowdfunding.shareUSSD.step2.part2')}
        </p>
      </section>
      <FeedBack />
    </article>
  )
}

export default ShareUSSD
